<div
  *ngFor="let group of groups$ | async; trackBy: trackGroupByPetNrId"
  class="bg-white shadow-lg min-h-[100%] flex-grow flex flex-col px-6 pt-4 pb-4 rounded-lg mb-4"
  [ngClass]="{ 'gap-4 pb-6': !group.minimized }"
>
  <!-- Description banner -->
  <div
    class="w-full text-lg flex justify-between items-center font-bold text-sigecom-info"
  >
    <span> Chaves do sorteio - {{ group.description }} </span>
    <fa-icon
      (click)="toggleGroupMinimize(group)"
      icon="chevron-down"
      class="cursor-pointer transition-all duration-300"
      [ngClass]="{ 'rotate-180': group.minimized }"
    />
  </div>

  <!-- Keys grid -->
  <div
    class="grid xl:grid-cols-8 overflow-hidden lg:grid-cols-6 md:grid-cols-4 sm:grid-cols-2 gap-2 text-center"
    [ngClass]="{ 'h-0': group.minimized }"
  >
    <div
      *ngFor="let item of group.keys; trackBy: trackClashById"
      class="bg-[#E5E7EB] col-span-1 gap-2 flex flex-col items-center justify-start pt-2 pb-4 rounded-lg"
    >
      <p class="font-bold py-1 text-sigecom-info">
        {{ item.cheTxNome }}
      </p>

      <div class="flex flex-col px-4 gap-2 w-full">
        <ng-container *ngFor="let slot of getSlots(item); let i = index">
          <ng-container *ngIf="item.inscricoesChave![i] as inc; else emptySlot">
            <sigecom-button
              [title]="
                inc.estTxSigla.length > 4 && !inc.ichBlSede
                  ? inc.estTxSigla.substring(0, 5) + '...'
                  : inc.estTxSigla
              "
              [attr.title]="inc.estTxSigla"
              [icon]="i == 0 ? 'key' : undefined"
              [type]="i == 0 ? 'head' : 'selected'"
              class="w-full !cursor-default"
            />
          </ng-container>

          <ng-template #emptySlot>
            <sigecom-button
              title="-"
              class="w-full !cursor-default"
              [icon]="i == 0 ? 'key' : undefined"
              [type]="i == 0 ? 'head' : 'void'"
            />
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</div>
